import React, { useRef, useState } from "react";
import { connect } from "react-redux";
import { format } from "date-fns";
import styles from "./styles";
import { withRouter } from "react-router";
import {
    Table,
    TableContainer,
    TableHead,
    TableBody,
    TablePagination,
    IconButton,
    Typography,
    Backdrop,
    CircularProgress,
    Box,
    Container,
} from "@material-ui/core";
import * as actions from "../../../actions/grillaPrincipal";
import * as actionsVentanaDialogo from "../../../actions/ventanaDialogo";
import {
    CeldaPersonalizada,
    HeaderTableRow,
    PersonalizadaTableRow,
    TableSortLabelPersonalizada,
} from "./personalizaciones";

import PencilIcon from "../../../assets/iconos/pencil-icon.png";
import SinResultado from "../SinResultado/SinResultado";

import  Botones  from "../Botones/Botones";

const Tabla = (props) => {
    const classes = styles();
    const tablaBodyRef = useRef();

    const initState = {
        nroPresentacion: { campo: "id", order: "desc", activo: false },
        nroRecepcion: { campo: "nroRecepcion", order: "desc", activo: false },
        nroComprobante: { 
            campo: "comprobantes.nroComprobante", 
            order: "desc", 
            activo: false 
        },
        fechaPresentacion: {
            campo: "fechaPresentacion",
            order: "desc",
            activo: false,
        },
        codPrestador: { campo: "codPrestador", order: "desc", activo: false },
        fechaVencimiento: {
            campo: "fechaVencimiento",
            order: "desc",
            activo: false,
        },
        fechaEstado: { campo: "fechaEstado", order: "desc", activo: false },
        estado: {
            campo: "estado.descripcionWEB",
            order: "desc",
            activo: false,
        },
        razonSocial: { campo: "razonSocial", order: "desc", activo: false },
    };

    const [ordernamiento, updateOrdenamiento] = useState({
        ...initState,
        nroPresentacion: { ...initState.nroPresentacion, activo: true },
    });

    const cambiarPaginaHandler = (event, nuevaPagina) => {
        const filtrar = { page: nuevaPagina };
        props.cambiarPaginaFilasTabla(filtrar);
    };
    const cambiarPaginaHandlerInput = (nuevaPagina) => {
        if (!nuevaPagina.target.value) return
        if (+nuevaPagina.target.value === props.paginaActual+1) {
            return nuevaPagina.target.value = ''
        }

        let pagina =  parseInt(nuevaPagina.target.value) - 1;
        nuevaPagina.target.placeholder = pagina + 1;
        nuevaPagina.target.value = '';
        if (pagina < 0 ){
            pagina = 0;
        }else{
            if (pagina > Math.ceil(props.cantidadTotal / props.filasPorPagina) -1 )
                pagina = Math.ceil(props.cantidadTotal / props.filasPorPagina) -1
        }
        const filtrar = { page: pagina };
        props.cambiarPaginaFilasTabla(filtrar);
    };

    const cambiarPaginaHandlerKey = (nuevaPagina) => {
        if (nuevaPagina.key === 'Enter'){
            cambiarPaginaHandlerInput(nuevaPagina);
        }
    }

    const cambiarFilasPorPaginaHandler = (event) => {
        const cantidad = parseInt(event.target.value, 10);
        const filtrar = { size: cantidad, page: 0 };
        props.cambiarPaginaFilasTabla(filtrar);
    };

    const cerrarDialogo = () => {
        const ventanaConfig = {
            estaVisible: false,
        };

        props.actualizarAtriutoVentanaDialogo(ventanaConfig);
    };

    const mostrarDialogoPresentacion = (presentacion) => {
        const tituloAux =
            presentacion.estado.descripcionWEB === "Observado"
                ? "observada"
                : "rechazada";

        const mensaje =
            presentacion.tipoMotivo !== null
                ? [
                      <Typography key="motivo" className={classes.textoVentana}>
                          {"Motivo: " + presentacion.tipoMotivo.descripcion}
                      </Typography>,
                  ]
                : [];

        mensaje.push(
            <Typography key="descripcion" className={classes.textoVentana}>
                {presentacion.comentario}
            </Typography>
        );

        const ventanaConfig = {
            estaVisible: true,
            titulo: "La presentación fue " + tituloAux,
            contenido: mensaje,
            clickAceptar: cerrarDialogo,
        };

        props.actualizarAtriutoVentanaDialogo(ventanaConfig);
    };

    const vaciarFiltros = () => {
        props.actualizarAtriutoGrilla({
            filtro: null,
            filtroActivo: false,
        });
    };

    const filaClickHandle = (presentacion) => {
        vaciarFiltros();
        props.history.push("/ver/" + presentacion.id + "/" + presentacion.tipoPresentacion.id);
    };

    const dirigirEditarPresentacion = (presentacion) => {
        vaciarFiltros();
        props.history.push("/editar/" + presentacion.id + "/" + presentacion.tipoPresentacion.id);
    };

    const ordenarTablaPorColumna = (atributo) => {
        const estado = ordernamiento[atributo];
        const ordenar = estado.order === "asc" ? "desc" : "asc";

        updateOrdenamiento({
            ...initState,
            [atributo]: { ...estado, order: ordenar, activo: true },
        });

        const valorOrdenamieto = estado.campo + "," + ordenar;
        props.setFiltroGrilla({ sort: valorOrdenamieto });

        const filtro = { ...props.filtro, sort: valorOrdenamieto, page: 0 };
        props.getPresentaciones(filtro);
    };

    const encabezadoDeTabla = () => {
        return (
            <HeaderTableRow className={ classes.tableHeader }>
                <CeldaPersonalizada align="center">
                    <TableSortLabelPersonalizada
                        active={ordernamiento.nroPresentacion.activo}
                        direction={ordernamiento.nroPresentacion.order}
                        onClick={() =>
                            ordenarTablaPorColumna("nroPresentacion")
                        }
                    >
                        Nº presentación
                    </TableSortLabelPersonalizada>
                </CeldaPersonalizada>
                <CeldaPersonalizada align="center">
                    <TableSortLabelPersonalizada
                        active={ordernamiento.fechaPresentacion.activo}
                        direction={ordernamiento.fechaPresentacion.order}
                        onClick={() =>
                            ordenarTablaPorColumna("fechaPresentacion")
                        }
                    >
                        Fecha
                    </TableSortLabelPersonalizada>
                </CeldaPersonalizada>
                <CeldaPersonalizada align="center">
                    <TableSortLabelPersonalizada
                        active={ordernamiento.estado.activo}
                        direction={ordernamiento.estado.order}
                        onClick={() => ordenarTablaPorColumna("estado")}
                    >
                        Estado
                    </TableSortLabelPersonalizada>
                </CeldaPersonalizada>
                <CeldaPersonalizada align="center">
                    <TableSortLabelPersonalizada
                        active={ordernamiento.fechaEstado.activo}
                        direction={ordernamiento.fechaEstado.order}
                        onClick={() => ordenarTablaPorColumna("fechaEstado")}
                    >
                        Fecha estado
                    </TableSortLabelPersonalizada>
                </CeldaPersonalizada>
                <CeldaPersonalizada align="center">
                    <TableSortLabelPersonalizada
                        active={ordernamiento.fechaVencimiento.activo}
                        direction={ordernamiento.fechaVencimiento.order}
                        onClick={() =>
                            ordenarTablaPorColumna("fechaVencimiento")
                        }
                    >
                        Vencimiento
                    </TableSortLabelPersonalizada>
                </CeldaPersonalizada>
                <CeldaPersonalizada align="center">
                    <TableSortLabelPersonalizada
                        active={ordernamiento.codPrestador.activo}
                        direction={ordernamiento.codPrestador.order}
                        onClick={() => ordenarTablaPorColumna("codPrestador")}
                    >
                        Nº prestador
                    </TableSortLabelPersonalizada>
                </CeldaPersonalizada>
                <CeldaPersonalizada align="center">
                    <TableSortLabelPersonalizada
                        active={ordernamiento.razonSocial.activo}
                        direction={ordernamiento.razonSocial.order}
                        onClick={() => ordenarTablaPorColumna("razonSocial")}
                    >
                        Razón social
                    </TableSortLabelPersonalizada>
                </CeldaPersonalizada>
                <CeldaPersonalizada align="center">
                    <TableSortLabelPersonalizada
                        active={ordernamiento.nroRecepcion.activo}
                        direction={ordernamiento.nroRecepcion.order}
                        onClick={() => ordenarTablaPorColumna("nroRecepcion")}
                    >
                        Nº recepción
                    </TableSortLabelPersonalizada>
                </CeldaPersonalizada>
                <CeldaPersonalizada align="center">
                    <TableSortLabelPersonalizada
                        active={ordernamiento.nroComprobante.activo}
                        direction={ordernamiento.nroComprobante.order}
                        onClick={() => ordenarTablaPorColumna("nroComprobante")}
                    >
                        Nº Factura
                    </TableSortLabelPersonalizada>
                </CeldaPersonalizada>
                <CeldaPersonalizada align="center">Opciones</CeldaPersonalizada>
            </HeaderTableRow>
        );
    };

    const dibujarDescripcinEstado = (estado) => {
        let estadoClase = null;

        switch (estado.id) {
            case 1:
            case 2:
                estadoClase = classes.verificacion;
                break;
            case 3:
                estadoClase = classes.observado;
                break;
            case 4:
                estadoClase = classes.rechazado;
                break;
            case 5:
            case 6:
            case 7:
                estadoClase = classes.finalizado;
                break;
            default:
                break;
        }

        return (
            <div className={`${classes.estado}  ${estadoClase}`}>
                {estado.descripcionWEB}
            </div>
        );
    };

    const mostrarPresentaciones = () => {
        return props.presentaciones.map((presentacion) => (
            <PersonalizadaTableRow key={presentacion.id} hover>
                <CeldaPersonalizada
                    onClick={() => filaClickHandle(presentacion)}
                >
                    {presentacion.id}
                </CeldaPersonalizada>
                <CeldaPersonalizada
                    onClick={() => filaClickHandle(presentacion)}
                >
                    {format(
                        new Date(presentacion.fechaPresentacion),
                        "dd/MM/yyyy"
                    )}
                </CeldaPersonalizada>
                <CeldaPersonalizada
                    className={classes.colEstado}
                    onClick={() => filaClickHandle(presentacion)}
                >
                    {dibujarDescripcinEstado(presentacion.estado)}
                </CeldaPersonalizada>
                <CeldaPersonalizada
                    onClick={() => filaClickHandle(presentacion)}
                >
                    {format(new Date(presentacion.fechaEstado), "dd/MM/yyyy")}
                </CeldaPersonalizada>
                <CeldaPersonalizada
                    onClick={() => filaClickHandle(presentacion)}
                >
                    {presentacion.estado.descripcionWEB === "Observado"
                        ? format(
                              new Date(presentacion.fechaVencimiento),
                              "dd/MM/yyyy"
                          )
                        : null}
                </CeldaPersonalizada>
                <CeldaPersonalizada
                    onClick={() => filaClickHandle(presentacion)}
                >
                    {presentacion.codPrestador}
                </CeldaPersonalizada>
                <CeldaPersonalizada
                    className={classes.colRazonSocial}
                    onClick={() => filaClickHandle(presentacion)}
                >
                    {presentacion.razonSocial}
                </CeldaPersonalizada>
                <CeldaPersonalizada
                    onClick={() => filaClickHandle(presentacion)}
                >
                    {presentacion.nroRecepcion}
                </CeldaPersonalizada>
                <CeldaPersonalizada
                    onClick={() => filaClickHandle(presentacion)} //nro comprobante
                >
                    { presentacion.comprobantes.length>0?presentacion.comprobantes[0].nroComprobante.toUpperCase():null }
                </CeldaPersonalizada>
                <CeldaPersonalizada align="right">
                    {mostrarIconosParaPresentacion(presentacion)}
                </CeldaPersonalizada>
            </PersonalizadaTableRow>
        ));
    };

    const costruirIconosObservada = (presentacion) => {
        return (
            <>
                <IconButton
                    aria-label="Editar"
                    size="small"
                    onClick={() => mostrarDialogoPresentacion(presentacion)}
                    className={classes.containerAdvertencia}
                >
                    <Typography className={classes.advertenciaIcono}>
                        !
                    </Typography>
                </IconButton>
                <IconButton
                    aria-label="Editar"
                    size="small"
                    className={classes.containerLapiz}
                    onClick={() => dirigirEditarPresentacion(presentacion)}
                >
                    <img
                        src={PencilIcon}
                        alt="Editar"
                        className={classes.lapizIcono}
                    />
                </IconButton>
            </>
        );
    };

    const costruirIconosRechazada = (presentacion) => {
        return (
            <IconButton
                aria-label="Editar"
                size="small"
                className={classes.containerAdvertencia}
                onClick={() => mostrarDialogoPresentacion(presentacion)}
            >
                <Typography className={classes.advertenciaIcono}>!</Typography>
            </IconButton>
        );
    };

    const mostrarIconosParaPresentacion = (presentacion) => {
        let iconos = null;

        if (presentacion.estado.descripcionWEB === "Observado") {
            iconos = costruirIconosObservada(presentacion);
        } else if (presentacion.estado.descripcionWEB === "Rechazado") {
            iconos = costruirIconosRechazada(presentacion);
        }

        return iconos;
    };

    const mostrarMensajeTablaVacia = () => {
        return <>
                <SinResultado /> 
                <Container className={classes.filaContainerBoton}>  
                    <Botones/> 
                </Container>
               </>;
    };

    const createLabelDisplayedRows = () => {
        return (
            <span>
                <input
                    type="number"
                    className={`${classes.inputFrom} ${classes.placeholderPaginationInputNumber}`}
                    min={1}
                    max={Math.ceil(props.cantidadTotal / props.filasPorPagina)}
                    placeholder={props.paginaActual + 1}
                    oldvalue={props.paginaActual + 1}
                    onMouseDown={(evt) => {
                        if (evt.target.value) return
                        evt.target.value = props.paginaActual + 1;
                    }}
                    onBlur={cambiarPaginaHandlerInput}
                    onKeyPress={cambiarPaginaHandlerKey}
                />
                {` de ${Math.ceil(props.cantidadTotal / props.filasPorPagina)}`}
            </span>
        )
    }

    const mostrarTablaPresentaciones = () => {
        if (props.presentaciones.length === 0 && !props.fetching) {
            return mostrarMensajeTablaVacia();
        }

        if (props.fetching) {
            document.body.style.overflowY = 'hidden';
            const hasVerticalScrollbar = document.body.parentElement.scrollHeight > document.body.parentElement.clientHeight;
            if (hasVerticalScrollbar) {
                document.body.style.paddingRight = '16px';
            }

            if (tablaBodyRef.current) {
                tablaBodyRef.current.scroll(0,0)
            }
        } else {
            document.body.style.overflowY = 'auto';
            document.body.style.paddingRight = '0px';
        }

        return (
            <>
                <TableContainer className={classes.containerTabla} innerRef={tablaBodyRef}>
                    <Table aria-label="tabla presentaciones" padding="normal">
                        <TableHead>{encabezadoDeTabla()}</TableHead>
                        <TableBody className={classes.tablaHeader}>{mostrarPresentaciones()}</TableBody>                 
                    </Table>
                </TableContainer>
                <Container className={classes.filaContainer}>
                    <TablePagination
                        rowsPerPageOptions={[]}
                        component="div"
                        count={props.cantidadTotal}
                        rowsPerPage={props.filasPorPagina}
                        page={props.paginaActual}
                        onChangePage={cambiarPaginaHandler}
                        onChangeRowsPerPage={cambiarFilasPorPaginaHandler}
                        labelDisplayedRows={createLabelDisplayedRows}
                    />
                    <Botones/>
                </Container>
            </>
        );
    };

    return (
        <Box mt={5} className={classes.boxContainer}>
            <Container className={classes.filaContainer}>
                <Typography className={classes.titulo}>
                    {props.filtroActivo
                        ? "Resultados de la búsqueda"
                        : "Mis presentaciones"}
                </Typography>
                <div className={classes.contadorFiltro}>
                    Total presentaciones: 
                    <span 
                        className={classes.contadorFiltroNumero}> { props.cantidadTotal } 
                    </span>
                </div>
            </Container>
            {mostrarTablaPresentaciones()}
            {props.fetching && (
                <Backdrop className={classes.backdrop} open={true}>
                    <CircularProgress color="primary" />
                </Backdrop>
                )
            }
        </Box>
    );
};

const mapStateToProps = (state) => ({
    filtroActivo: state.grillaPrincipalReducer.filtroActivo,
    filtro: state.grillaPrincipalReducer.filtro,
    presentaciones: state.grillaPrincipalReducer.presentaciones,
    cantidadTotal: state.grillaPrincipalReducer.cantidadTotal,
    paginaActual: state.grillaPrincipalReducer.paginaActual,
    filasPorPagina: state.grillaPrincipalReducer.filasPorPagina,
    fetching: state.grillaPrincipalReducer.fetching,
});

const actionCreators = {
    cambiarPaginaFilasTabla: actions.cambiarPaginaFilasTabla,
    actualizarAtriutoGrilla: actions.actualizarAtriutoGrilla,
    setFiltroGrilla: actions.setFiltroGrilla,
    getPresentaciones: actions.getPresentaciones,
    actualizarAtriutoVentanaDialogo:
        actionsVentanaDialogo.actualizarAtriutoVentanaDialogo,
};

export default connect(mapStateToProps, actionCreators)(withRouter(Tabla));
